export default __webpack_public_path__ + "fab44a5806fef7bc08bb8eaea7489483.png";